<template>
    <div class="header">
        <v-container
            class="pa-0"
            fluid
        >
            <v-row>
                <v-col cols="12">
                    <header-toolbar></header-toolbar>
                </v-col>
            </v-row>
            <v-row class="mt-16 d-none d-lg-flex">
                <v-col cols="5">
                    <header-logo></header-logo>
                </v-col>
                <v-col cols="7">
                    <header-links></header-links>
                </v-col>
            </v-row>
            <v-row class="mt-16 d-flex d-lg-none">
                <v-col
                    class="d-flex justify-start align-center"
                    cols="1"
                >
                    <feedback-form-header-button />
                </v-col>
                <v-col
                    class="d-flex justify-center"
                    cols="10"
                >
                    <header-logo></header-logo>
                </v-col>
                <v-col
                    class="d-flex justify-end align-center"
                    cols="1"
                >
                    <svg
                        width="40"
                        height="40"
                        viewBox="0 0 40 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        @click.stop="this.drawer = !this.drawer"
                    >
                        <path
                            d="M38.7778 30L31.4722 22.6944C30.9167 23.1759 30.2689 23.5509 29.5289 23.8194C28.7889 24.088 28.0015 24.2222 27.1667 24.2222C25.1637 24.2222 23.4685 23.5278 22.0811 22.1389C20.6937 20.75 20 19.0741 20 17.1111C20 15.1481 20.6944 13.4722 22.0833 12.0833C23.4722 10.6944 25.1528 10 27.125 10C29.0972 10 30.7731 10.6944 32.1528 12.0833C33.5324 13.4722 34.2222 15.1495 34.2222 17.1153C34.2222 17.9088 34.0926 18.6759 33.8333 19.4167C33.5741 20.1574 33.1852 20.8519 32.6667 21.5L40 28.7778L38.7778 30ZM27.1389 22.5556C28.6435 22.5556 29.9225 22.0231 30.9757 20.9583C32.0289 19.8935 32.5556 18.6111 32.5556 17.1111C32.5556 15.6111 32.0289 14.3287 30.9757 13.2639C29.9225 12.1991 28.6435 11.6667 27.1389 11.6667C25.6188 11.6667 24.3268 12.1991 23.2627 13.2639C22.1987 14.3287 21.6667 15.6111 21.6667 17.1111C21.6667 18.6111 22.1987 19.8935 23.2627 20.9583C24.3268 22.0231 25.6188 22.5556 27.1389 22.5556Z"
                            fill="white"
                        />
                        <path
                            d="M5 10H21L20.4303 10.3798C19.8207 10.7862 19.3277 11.3447 19 12H5V10ZM5 19H17V21H5V19ZM5 28H31L32 29L33 30H5V28Z"
                            fill="white"
                        />
                    </svg>
                </v-col>
            </v-row>
        </v-container>
    </div>
    <v-navigation-drawer
        v-model="this.drawer"
        location="right"
        temporary
    >
        <v-container class="mobile-menu-container">
            <div>
                <v-icon
                    class="close-btn"
                    icon="mdi-close"
                    color="#001FA3"
                    size="x-large"
                    @click.stop="this.drawer = false"
                />
                <div class="mobile-links">
                    <router-link
                        v-for="(link, index) in links"
                        :key="index"
                        :to="link.path"
                        class="mobile-link"
                    >
                        {{ link.text }}
                    </router-link>
                </div>
            </div>
            <div class="social-networks">
                <div class="mt-4">
                    <footer-text
                        text="РАИИ В СОЦИАЛЬНЫХ СЕТЯХ"
                        class="mobile-footer-text"
                    />
                </div>
                <div class="mt-6">
                    <div class="d-flex justify-center mobile-menu-networks">
                        <a
                            href="https://vk.com/raai_school"
                            target="_blank"
                        >
                            <svg
                                class="icon"
                                width="36"
                                height="36"
                                viewBox="0 0 36 36"
                                fill="#A2A2A2"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M23.5314 0.5H12.4866C2.3994 0.5 0 2.83275 0 12.6222V23.3602C0 33.1655 2.3814 35.5 12.4686 35.5H23.5134C33.5988 35.5 36 33.1847 36 23.3778V12.6398C36 2.83275 33.6186 0.5 23.5314 0.5ZM29.0628 25.4725H26.4366C25.443 25.4725 25.1442 24.6903 23.3622 22.9578C21.807 21.5 21.15 21.318 20.7558 21.318C20.2122 21.318 20.0628 21.4632 20.0628 22.193V24.489C20.0628 25.1103 19.8558 25.4743 18.1872 25.4743C16.5678 25.3684 14.9975 24.8901 13.6055 24.0787C12.2135 23.2672 11.0397 22.1459 10.1808 20.807C8.1417 18.3395 6.7229 15.4435 6.0372 12.3492C6.0372 11.966 6.1866 11.6195 6.9372 11.6195H9.5616C10.2366 11.6195 10.4796 11.9117 10.7442 12.5855C12.0186 16.2325 14.193 19.4035 15.075 19.4035C15.4134 19.4035 15.561 19.2582 15.561 18.4375V14.682C15.4494 12.9688 14.5134 12.8235 14.5134 12.204C14.5254 12.0406 14.6024 11.8882 14.7281 11.7791C14.8538 11.6699 15.0182 11.6127 15.1866 11.6195H19.3122C19.8756 11.6195 20.0628 11.8925 20.0628 12.5487V17.6168C20.0628 18.1645 20.3058 18.3465 20.475 18.3465C20.8134 18.3465 21.0744 18.1645 21.6936 17.5625C23.0236 15.9857 24.1102 14.2289 24.9192 12.3475C25.0019 12.1215 25.1584 11.928 25.3647 11.7966C25.5711 11.6651 25.8161 11.603 26.0622 11.6195H28.6884C29.475 11.6195 29.6424 12.0028 29.475 12.5487C28.5201 14.6285 27.3385 16.6027 25.9506 18.4375C25.668 18.8575 25.5546 19.0763 25.9506 19.568C26.2116 19.9513 27.1314 20.6985 27.7506 21.409C28.6504 22.2816 29.3977 23.2912 29.9628 24.398C30.1878 25.1085 29.8116 25.4725 29.0628 25.4725Z"
                                />
                            </svg>
                        </a>
                        <a
                            href="https://youtube.com/@user-bb6kr3tv1f?si=oVkGh7R0itIe7oA5"
                            target="_blank"
                            class="ml-4"
                        >
                            <svg
                                class="icon"
                                width="47"
                                height="34"
                                viewBox="0 0 47 34"
                                fill="#A2A2A2"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M18.6668 23.875L30.5606 17L18.6668 10.125V23.875ZM45.1585 5.93123C45.4564 7.00831 45.6627 8.45206 45.8002 10.2854C45.9606 12.1187 46.0293 13.7 46.0293 15.075L46.1668 17C46.1668 22.0187 45.8002 25.7083 45.1585 28.0687C44.5856 30.1312 43.2564 31.4604 41.1939 32.0333C40.1168 32.3312 38.146 32.5375 35.121 32.675C32.1418 32.8354 29.4147 32.9041 26.8939 32.9041L23.2502 33.0416C13.6481 33.0416 7.66683 32.675 5.30641 32.0333C3.24391 31.4604 1.91475 30.1312 1.34183 28.0687C1.04391 26.9916 0.837663 25.5479 0.700163 23.7146C0.539746 21.8812 0.470996 20.3 0.470996 18.925L0.333496 17C0.333496 11.9812 0.700163 8.29165 1.34183 5.93123C1.91475 3.86873 3.24391 2.53956 5.30641 1.96665C6.3835 1.66873 8.35433 1.46248 11.3793 1.32498C14.3585 1.16456 17.0856 1.09581 19.6064 1.09581L23.2502 0.958313C32.8522 0.958313 38.8335 1.32498 41.1939 1.96665C43.2564 2.53956 44.5856 3.86873 45.1585 5.93123Z"
                                />
                            </svg>
                        </a>
                        <a
                            href="https://t.me/raai_official"
                            target="_blank"
                            class="ml-4"
                        >
                            <svg
                                class="icon"
                                width="37"
                                height="38"
                                viewBox="0 0 37 38"
                                fill="#A2A2A2"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M18.5832 0.666687C8.69317 0.666687 0.666504 8.88002 0.666504 19C0.666504 29.12 8.69317 37.3334 18.5832 37.3334C28.4732 37.3334 36.4998 29.12 36.4998 19C36.4998 8.88002 28.4732 0.666687 18.5832 0.666687ZM26.8965 13.1334C26.6278 16.03 25.4632 23.07 24.8719 26.315C24.6211 27.69 24.1194 28.1484 23.6536 28.2034C22.6144 28.295 21.8261 27.5067 20.8228 26.8284C19.2461 25.765 18.3503 25.105 16.8273 24.0784C15.0536 22.8867 16.2003 22.2267 17.2215 21.1634C17.4903 20.8884 22.0769 16.6167 22.1665 16.2317C22.1789 16.1734 22.1773 16.1128 22.1617 16.0553C22.1461 15.9978 22.117 15.9451 22.0769 15.9017C21.9694 15.81 21.8261 15.8467 21.7007 15.865C21.5394 15.9017 19.0311 17.6067 14.1398 20.98C13.4232 21.475 12.7782 21.7317 12.2048 21.7134C11.5598 21.695 10.3415 21.3467 9.42775 21.035C8.299 20.6684 7.42109 20.4667 7.49275 19.825C7.52859 19.495 7.9765 19.165 8.81859 18.8167C14.0503 16.4884 17.5261 14.9484 19.264 14.215C24.2448 12.0884 25.2661 11.7217 25.9469 11.7217C26.0903 11.7217 26.4307 11.7584 26.6457 11.9417C26.8248 12.0884 26.8786 12.29 26.8965 12.4367C26.8786 12.5467 26.9144 12.8767 26.8965 13.1334Z"
                                />
                            </svg>
                        </a>
                    </div>
                </div>
            </div>
        </v-container>
    </v-navigation-drawer>
</template>

<script>
import HeaderLogo from './HeaderLogo.vue'
import HeaderLinks from './HeaderLinks.vue'
import HeaderToolbar from './HeaderToolbar.vue'
import FooterText from '@/components/footer/FooterText.vue'
import FeedbackFormHeaderButton from '../forms/FeedbackFormHeaderButton.vue'
export default {
    name: 'HeaderComponent',
    components: {
        HeaderLogo,
        HeaderLinks,
        HeaderToolbar,
        FooterText,
        FeedbackFormHeaderButton
    },
    data() {
        return {
            drawer: false,
            links: [
                { path: '/about/raai_goals', text: 'О РАИИ' },
                { path: '/all_news_page', text: 'Новости' },
                { path: '/all_conferences', text: 'Конференции' },
                { path: '/all_personalities', text: 'Персоналии' },
                { path: '/resources', text: 'Медиаресурсы' },
                {
                    path: 'about/1/1',
                    text: 'Документы'
                },
                { path: '/library', text: 'Библиотека' }
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
.mobile-menu-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
}

.close-btn {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-left: auto;
}

.mobile-links {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.mobile-link {
    font-size: 20px;
    line-height: 19px;
    font-weight: 500;
    text-decoration: none;
    color: #001fa3;
    text-align: right;
}

.mobile-footer-text {
    color: #001fa3 !important;
}

.mobile-menu-networks {
    svg {
        fill: #001fa3;
    }
}
</style>
